import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { NumberUtilities } from "../utilities/number-utilities";
import * as moment from "moment";

export class DateTimeHelper {

    public static getUtcNow(): string {
        const now: Date = new Date();
        return now.toJSON();
    }

    public static getTodayNoDate(): Date {
        return new Date((this.getDateString(new Date())));
    }

    public static getUtcNowOffsetted(): string {
        const now: Date = new Date();
        return new Date(now.getTime() + now.getTimezoneOffset() * 60000).toJSON();
    }

    public static getDateOffsetted(date: Date): string {
        return new Date(date.getTime() + (date.getTimezoneOffset() + ((<any>moment(date)).isDST() ? 60 : 0)) * 60000).toJSON()
    }

    public static getDateString(date: Date | string): string {
        let dateFromString: Date;
        if (typeof date === "string") {
            dateFromString = new Date(date);
        }
        const dateValue: Date = typeof date === "string" ? dateFromString : date;
        return dateValue.getFullYear() +
            "-" +
            (NumberUtilities.pad2(dateValue.getMonth() + 1)) +
            "-" +
            NumberUtilities.pad2(dateValue.getDate());
    }

    public static getDateFormatted(value: any, format: string = ConfigService.instance().config.common.defaultDateTimeFormat): string {
        return moment(new Date(value)).format(format);
    }

    public static getFormattedDate(date: Date): string {
        const dateStr = NumberUtilities.pad2(date.getDate()) + "/" +
            (NumberUtilities.pad2(date.getMonth() + 1)) +
            "/" + date.getFullYear();
        return dateStr;
    }
}
